// src/App.js
//
// Top-level entry.
//
// PHASE 1 PROMOTED (2026-06-05, Nigel sign-off): FoamFlow is now the app for
// the registration flavors. The flavor (config/flavor.js) still controls which
// Firestore collections are used and whether the PREVIEW banner shows:
//   - REACT_APP_FLAVOR=prod    → FoamFlow + production collections (my.waka.surf)
//   - REACT_APP_FLAVOR=preview → FoamFlow + *_preview collections + banner
//     (waka-my-preview.web.app — stays alive for Phase 2 testing)
//
// The demo.waka.surf Demo Day app moved to its own repo 2026-07-22
// (~/dev/waka-demo) — this app is registration-only again.
//
// LegacyApp (ProductRegistration) is retained below for emergency reference
// only — rollback is via `firebase hosting:clone` (previous deploy version),
// NOT by flipping this switch.
//
// Admin retirement (2026-05-17): /admin and /admin/* redirect to helm.waka.surf
// in the registration flavors. The AdminPanel React app was retired; helm is
// the new admin.

import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ProductRegistration from './components/ProductRegistration';
import FoamFlow from './components/foam/FoamFlow';

function AdminRedirect() {
  useEffect(() => {
    window.location.replace('https://helm.waka.surf/customers');
  }, []);
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      minHeight: '60vh', fontFamily: 'sans-serif',
      color: '#475569', fontSize: '14px',
      padding: '24px', textAlign: 'center',
    }}>
      <div>
        Admin has moved to{' '}
        <a href="https://helm.waka.surf/customers" style={{ color: '#0F1B2D', fontWeight: 600 }}>
          helm.waka.surf/customers
        </a>
        . Redirecting…
      </div>
    </div>
  );
}

function LegacyApp() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ProductRegistration />} />
        <Route path="/r/:sku" element={<ProductRegistration />} />
        <Route path="/admin" element={<AdminRedirect />} />
        <Route path="/admin/*" element={<AdminRedirect />} />
      </Routes>
    </BrowserRouter>
  );
}

// eslint-disable-next-line no-unused-vars -- retained for emergency reference (see header)
const _RetiredLegacyApp = LegacyApp;

function App() {
  return <FoamFlow />;
}

export default App;
